import { render, staticRenderFns } from "./service-company-info-cn.vue?vue&type=template&id=f962050c&"
import script from "./service-company-info-cn.vue?vue&type=script&lang=js&"
export * from "./service-company-info-cn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports